import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

interface ConditionalComponentProps {
  children: React.ReactNode;
  name?: string;
  isDependent?: boolean;
  dependentValue?: any;
  dependentInputValue?: any;
  getDependentValue?: () => any;
}
export const ConditionalComponent = ({
  children,
  name,
  isDependent,
  dependentInputValue,
  dependentValue,
  getDependentValue,
}: ConditionalComponentProps) => {
  const { unregister } = useFormContext();
  useEffect(() => {
    return () => {
      if (
        name &&
        isDependent &&
        getDependentValue &&
        dependentInputValue !== getDependentValue()
      ) {
        unregister(name);
      }
    };
  }, [isDependent, dependentInputValue, dependentValue, name]);

  if (isDependent && dependentValue === dependentInputValue) {
    return <>{children}</>;
  } else if (isDependent && dependentValue !== dependentInputValue) {
    return null;
  }
  return <>{children}</>;
};
